import React, { useState } from "react";
import { EditableTextField,EditableSelectField ,RadioOptions} from "../../../../Global_Component/CustomInputComponent";

import OPTIONS from "../../../../constant/Option";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";
import { CustomSecondaryButton, CustomSuccessButton } from "../../../../Global_Component/GlobalButtonComponent";

const ManufacturingProfile = ({MoveToNextTab,MoveToPreviousTab}) => {
  const [uploadedFiles, setUploadedFiles] = useState({});

  const handleFileUpload = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "#fff",
      
        "&::-webkit-scrollbar": {
          width: "6px", // Width of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Track color
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Thumb color
          borderRadius: "10px", // Optional rounded edges for the thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555", // Thumb color on hover
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Plant details
      </Typography>

      <Grid
        container
        sm={12}
        md={12}
        lg={8}
        xl={9}
        spacing={0}
      >
       

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField name={"name"} label={"Plant Name"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
       
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField multiline name={"address"} label={"Plant  Address"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField multiline={true} name={"line"} label={"Plant Line Address (optional)"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableSelectField name={"country"}  options={OPTIONS.state.getAllOptions().map((option)=>{return {value:option,label:option}})} label={"Country"} value={"India"} isEdit={true}/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableSelectField name={"state"} options={OPTIONS.state.getAllOptions().map((option)=>{return {value:option,label:option}})} label={"State"} value={"India"} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField name={"city"} label={"City"} value={""} isEdit={true}/>
        </Grid>
        

        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableTextField name={"zipCode"} label={"Zip Code"} value={""} isEdit={true}/>
        </Grid>
       

        <Grid item md={12}sx={{p:1,m:0}}>
        <RadioOptions  options={[{label:"Trade/Exporter",value:"Trade"},{label:"Self Manufacture",value:"selfManfacture"},{label:"Contract Manufacturer",value:"contractManufacturer"}]} onChange={e=>{}} isEdit={true}/>
        </Grid>



        <Grid item md={12}sx={{p:1,my:1}}>
        <RadioOptions label={"Name of Industry"} value={"Pharmaceutical"}  options={[{label:"Food",value:"Food"},{label:"Non Food",value:"Non_Food"},{label:"Pharmaceutical",value:"Pharmaceutical"},{label:"Cosmeceutical",value:"Cosmeceutical"},{label:"Nutraceutical",value:"Nutraceutical"}]} onChange={e=>{}} isEdit={false}/>
        </Grid>

       
      </Grid>

     <Grid xs={12} sx={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:1}}>
      <CustomSecondaryButton label={"Back"} sx={{margin:2}} onClick={e=>MoveToPreviousTab()}/>
        <CustomSuccessButton label={"Next"} onClick={e=>MoveToNextTab()}/>
     </Grid>
    </Box>
  );
};

export default ManufacturingProfile;
